import { render } from "./index.vue?vue&type=template&id=2b067c84"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2b067c84&lang=scss"

import exportComponent from "/Users/yangshaohua/work/workspace/school-b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__